<template>
    <div :id="$route.name">
        <card back tools toolsColumns>
            <template v-slot:header>
                <h4 class="d-inline">تابلــو اعلانات </h4>
                <hr>    
            </template>
            <template v-slot:content>
                <tab :tab="Tablist">
                    <template v-slot:content0>
                        <div class="row">
                            <div class="mb-3">
                                <a v-if="AddModeUser == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="add(false)" title="افزودن اعلان جدید">
                                    <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
                                </a>
                                <a v-if="AddModeUser != 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="cancel()" title="لغو افزودن">
                                    <h4><i class="fas fa-times text-danger"></i></h4>
                                </a>
                            </div>
                            <div class="col-12" v-if="AddModeUser!=0" id="InsertBoarsUser">
                                <div class="row">
                                    <div class="col-md-12 col-12">
                                        <small id="users">کارمندان</small>
                                        <div dir="rtl">
                                            <treeselect
                                                name="demo3"
                                                :multiple="multiple"
                                                :clearable="clearable"
                                                :searchable="searchable"
                                                :disabled="disabled"
                                                :open-on-click="openOnClick"
                                                :open-on-focus="openOnFocus"
                                                :clear-on-select="clearOnSelect"
                                                :close-on-select="closeOnSelect"
                                                :always-open="alwaysOpen"
                                                :append-to-body="appendToBody"
                                                :options="options3"
                                                v-model="value3"
                                                :normalizer="normalizer3"
                                                @select="ItemSelected3"
                                                @deselect="ItemDeselect3">
                                            </treeselect>
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-12 mt-4">
                                        <small id="LblTitle">عنوان اعلان</small>
                                        <input  type="text" class="form-control required" v-model="DataAxios.Title"/>
                                        <div class="mt-2">
                                            <small id="LblStartDate" class="d-none">تاریخ شروع اعلان</small>
                                            <date-picker color="dimgray" input-class="required form-control" v-model="DataAxios.StartDate" clearable :editable="true" placeholder=" از تاریخ "></date-picker>
                                        </div>
                                        <div class="mt-2">
                                            <small id="LblEndDate" class="d-none">تاریخ پایان اعلان</small>
                                            <date-picker color="dimgray" input-class="required form-control" v-model="DataAxios.EndDate" clearable :editable="true" placeholder=" تا تاریخ "></date-picker>
                                        </div>
                                        <button v-if="!isEdit" class="btn btn-success mt-3 float-left w-100 text-center" dir="ltr" @click.prevent="SetData(false)">ثبت اعلان <i class="fad fa-plus mx-2 mt-2"></i></button>
                                        <button v-else class="btn btn-warning mt-3 float-left w-100 text-center" dir="ltr" @click.prevent="EditData(false)">ویرایش اعلان <i class="fad fa-plus mx-2 mt-2"></i></button>
                                    </div>
                                    <div class="col-md-9 col-12 mt-4">
                                        <small id="LblMessage">متن اعلان</small>
                                        <textarea class="form-control required" rows="8" v-model="DataAxios.Message"></textarea>
                                    </div>

                                </div>
                            </div>
                            <div class="col-12 mt-2" v-if="AddModeUser==0">
                                <bnp-grid v-if="$store.state.renderComponentGrid" :hasRowNum="true" :propsColumn="Column" :propsRows="Rows" :action="true">
                                    <template slot="action-slot" slot-scope="props">
                                        <a href="javascript:;" class="mr-2 badge"  @click="OnEditNew(props.props)"
                                        ><h5><span class="fas fa-marker text-secondary hover-warning"></span></h5
                                        ></a>
                                        
                                        <a href="javascript:;" class="mr-2 badge" @click="OnDetail(props.props)" data-title="کارمندان دریافت کننده اعلان"
                                        ><h6><span class="fad fa-info-circle hover-info"></span></h6
                                        ></a>

                                        <a href="javascript:;" class="mr-2 badge"  @click="removeBoard(props.props)" data-title="حذف"
                                        ><h5><span class="fad fa-trash hover-danger"></span></h5
                                        ></a>
                                    </template>
                                </bnp-grid>
                            </div>
                        </div>
                    </template>
                    <template v-slot:content1>
                        <div class="row">
                            <div class="mb-3">
                                <a v-if="AddModeCustomer == 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="add(true)" title="افزودن اعلان جدید">
                                    <h4><i class="fas fa-plus text-success" style="color: var(--logo-color) !important"></i></h4>
                                </a>
                                <a v-if="AddModeCustomer != 0" class="d-inline float-right mx-2 mt-1" href="javascript:;" @click="cancel()" title="لغو افزودن">
                                    <h4><i class="fas fa-times text-danger"></i></h4>
                                </a>
                            </div>
                            <div class="col-12" v-if="AddModeCustomer!=0"  id="InsertBoarsCustomer">
                                <div class="row">
                                    <div class="col-md-3 col-12 mt-4">
                                        <small id="LblTitle">عنوان اعلان</small>
                                        <input  type="text" class="form-control required" v-model="DataAxios.Title"/>
                                        <div class="mt-2">
                                            <small id="LblStartDate" class="d-none">تاریخ شروع اعلان</small>
                                            <date-picker color="dimgray" input-class="required form-control" v-model="DataAxios.StartDate" clearable :editable="true" placeholder=" از تاریخ "></date-picker>
                                        </div>
                                        <div class="mt-2">
                                            <small id="LblEndDate" class="d-none">تاریخ پایان اعلان</small>
                                            <date-picker color="dimgray" input-class="required form-control" v-model="DataAxios.EndDate" clearable :editable="true" placeholder=" تا تاریخ "></date-picker>
                                        </div>
                                        <button v-if="!isEdit" class="btn btn-success mt-3 float-left w-100 text-center" dir="ltr" @click.prevent="SetData(true)">ثبت اعلان <i class="fad fa-plus mx-2 mt-2"></i></button>
                                        <button v-else class="btn btn-warning mt-3 float-left w-100 text-center" dir="ltr" @click.prevent="EditData(true)">ویرایش اعلان <i class="fad fa-plus mx-2 mt-2"></i></button>
                                    </div>
                                    <div class="col-md-9 col-12 mt-4">
                                        <small id="LblMessage">متن اعلان</small>
                                        <textarea class="form-control required" rows="8" v-model="DataAxios.Message"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" v-if="AddModeCustomer==0">
                                 <bnp-grid v-if="$store.state.renderComponentGrid" :hasRowNum="true" :propsColumn="Column" :propsRows="RowsCustomer" :action="true">
                                    <template slot="action-slot" slot-scope="props">
                                        <a href="javascript:;" class="mr-2 badge" @click="OnEditNew(props.props)"
                                        ><h5><span class="fas fa-marker text-secondary hover-warning"></span></h5
                                        ></a>
                                        
                                       

                                        <a href="javascript:;" class="mr-2 badge" @click="removeBoard(props.props)" data-title="حذف"
                                        ><h5><span class="fad fa-trash hover-danger"></span></h5
                                        ></a>

                                    </template>
                                </bnp-grid>
                            </div>
                        </div>
                    </template>
                </tab>
            </template>
        </card>
        <b-modal size="xl" centered id="modal-NoticesRiz">
            <template #modal-header="{ close }">
                <b-button size="sm" variant="outline-danger" @click="close()">
                <span aria-hidden="true">&times;</span>
                </b-button>
                <h5>کارمندان دریافت کننده اعلان </h5>
            </template>

            <template #default>
                <div dir="rtl">
                <bnp-grid v-if="$store.state.renderComponentGridModal" :propsColumn="ColumnRiz" :propsRows="RowsRiz" :hasRowNum="true" :Selectable="false">
                    <template style="width:10% !important;" slot="ReadMessage" slot-scope="props" >
                        <span>{{ props.props.ReadMessage==true?'کارمند اعلان رو مشاهده ، و اعلان بسته شده':'اعلان باز میباشد' }}</span>
                    </template>
                </bnp-grid>
                </div>
            </template>
            <template #modal-footer="{ cancel }">
                <b-button id="CancelCopy" size="sm" variant="danger" @click="cancel()"> بستن </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Tab from '@/components/Tab/Tab.vue'
import Card from '../../../components/Card/Card.vue'
import Treeselect from '@riophae/vue-treeselect'
import BnpGrid from '../../../components/BnpGrid/BnpGrid.vue'
export default {
  components: { Card,Tab,Treeselect ,datePicker: VuePersianDatetimePicker, BnpGrid},
    data() {
        return{
            users:[],
            isEdit:false,
            Column:[],
            ColumnRiz:[],
            Rows:[],
            RowsRiz:[],
            RowsCustomer:[],
            DataAxios:{Id:1,tblUserGrpIdInsert:this.$session.get('UserInfo').tblUserGrpId,DateTimeLastEdit:"",DateTimeInsert:"",tblUserGrpIdLastEdit:this.$session.get('UserInfo').tblUserGrpId,IsCustomer:0,Archive:0},
            DataAxoisCol: {
                ArryfildValue: {
                SoftwareId: 2,
                UserId: 1,
                FormName: 'frmNoticeBoard',
                ShowView: 0,
                },
                Method: 'post',
                Action: 'ReadGridColumns',
            },
            DataAxoisColRiz: {
                ArryfildValue: {
                SoftwareId: 2,
                UserId: 1,
                FormName: 'frmNoticeBoardDetail',
                ShowView: 0,
                },
                Method: 'post',
                Action: 'ReadGridColumns',
            },
            AddModeUser:0,
            AddModeCustomer:0,
            Tablist: [
                { header: 'کارمـــندان', active: this.activeTab == 0 },
                { header: 'مشتـــریان', active: this.activeTab == 1 },
            ],
            options3: [],
            multiple: true,
            clearable: false,
            searchable: true,
            disabled: false,
            openOnClick: true,
            openOnFocus: false,
            clearOnSelect: true,
            closeOnSelect: false,
            alwaysOpen: false,
            appendToBody: false,
            value3: [],
            normalizer3(node) {
                return {
                    id: node.id,
                    label: node.name,
                }
            },
        }
    },
    methods: {
        add(isCustomer){
            this.cancel()
            if(isCustomer){
                this.AddModeCustomer = 1
            }else{
                this.value3 = []
                this.AddModeUser = 1
                this.users.forEach(element => {
                    this.value3.push(element.id)
                });
            }
        },

        EditData(isCustomer){

            let isValid = false
            if (isCustomer) {
               if (this.$ValidForm('InsertBoarsCustomer')) {
                    isValid = true
                }
            }
            else
            {
                if (this.$ValidForm('InsertBoarsUser')) {
                    isValid = true
                    let TblNoticeBoardRizList=[]

                    for (let index = 0; index < this.value3.length; index++) {
                        const element = this.value3[index];
                        var model={Id:1,ReadMessage:0,IsCustomer:0,tblUserId:element,tblNoticeBoardId:1,tblUserGrpIdInsert:this.$session.get('UserInfo').tblUserGrpId,tblUserGrpIdLastEdit:null,}
                        TblNoticeBoardRizList.push(model)
                    }
                    this.DataAxios.TblNoticeBoardRiz = TblNoticeBoardRizList
                }
            }
            // console.log('this.DataAxios', this.DataAxios);
            if(isValid){
                this.DataAxios.IsCustomer = isCustomer
                let DataAxios_Data={
                    Method: "post",
                    Action: 'NoticeBoard/Edit_TblNoticeBoard',
                    ArryfildValue: this.DataAxios
                }
                this.$PostData(DataAxios_Data).then((res)=>{
                    if(res.Status == "Ok"){
                        this.$SetLog(this.DataAxios, 0)
                        this.cancel()
                        this.Reload()
                        this.$mySweetDefaultTost('عملیات موفق', 'با موفقیت ویرایش شد', 'success', 1000)
                    }else{
                        this.$mySweetDefaultTost('', 'لطفا مجددا تلاش کنید', 'warning', 1500)
                    }

                }).catch((err)=>{
                    this.$mySweetDefaultTost('عملیات ناموفق', 'خطایی رخ داد', 'error', 3000)
                    console.error('CATCH', error)
                }).finally(()=>{
                    this.$store.state.renderComponentGrid=false
                    this.$nextTick(()=>{
                        this.$store.state.renderComponentGrid = true;
                    })
                })
            }
        },

        removeBoard(props){
            this.$store.state.OldDataForLog = JSON.stringify(props)
            const swalWithBootstrapButtons = this.$swal.mixin({
                customClass: {
                confirmButton: 'btn btn-success mx-1',
                cancelButton: 'btn btn-danger',
                },
                buttonsStyling: false,
            })
            swalWithBootstrapButtons
            .fire({
            title: 'اطمینان دارید؟',
            text: 'از حذف اعلان ' + '[' + props.Title + ']' + '؟',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'بله، حذف شود',
            cancelButtonText: 'لغو',
            reverseButtons: true,
            })
            .then((result) => {
            if (result.isConfirmed) {
                var DataaxiosDepUser = {
                Action: 'NoticeBoard/Delete_Borard',
                Method: 'Delete',
                ArryfildValue: {Id : props.Id}
                }
                this.$PostData(DataaxiosDepUser)
                .then((response) => {
                    this.$SetLog(this.DataAxios, 1)
                    if(props.IsCustomer){
                        var record = this.RowsCustomer.find(x=> x.Id == props.Id)
                        let index = this.RowsCustomer.indexOf(record)
                        this.RowsCustomer.splice(index, 1);

                    }else{
                        var record = this.Rows.find(x=> x.Id == props.Id)
                        let index = this.Rows.indexOf(record)
                        this.Rows.splice(index, 1);
                    }
                    swalWithBootstrapButtons.fire('', 'اعلان با موفقیت حذف شد', 'success')
                    this.$store.state.renderComponentGrid=false
                    this.$nextTick(()=>{
                        this.$store.state.renderComponentGrid = true;
                    })
                })
                .catch((error) => {
                    console.error('CATCH', error)
                })
            }
            })
        },
        OnEditNew(props){
            if(props.IsCustomer){
                this.AddModeCustomer = 1 
            }else{
                this.AddModeUser = 1
                this.value3 = []
                props.BoardRizUserId.forEach(el => {
                    this.value3.push(el)
                });
            }
            this.isEdit = true
            this.DataAxios.Id = props.Id
            this.DataAxios.StartDate = props.StartDate
            this.DataAxios.EndDate = props.EndDate
            this.DataAxios.Message = props.Message
            this.DataAxios.Title = props.Title
            this.$store.state.OldDataForLog = JSON.stringify(this.DataAxios)
        },
        cancel(){
            this.isEdit = false
            this.AddModeUser = 0
            this.AddModeCustomer = 0
            this.DataAxios.Id = 1
            this.DataAxios.StartDate = ''
            this.DataAxios.EndDate = ''
            this.DataAxios.Message = ''
            this.DataAxios.Title = ''
        },
        ItemSelected3(node) {
            this.value3.push(node.id)
        },
        ItemDeselect3(node) {
           for (let index = 0; index < this.value3.length; index++) {
                if (this.value3[index] == node.id) {
                this.value3.splice(index, 1)
                }
            }
        },
        GetDataUser(){
            let DataAxios_Data={
                    ArryfildValue: {},
                    Method: "post",
                    Action: 'TblCrmCombo/GetUserDatails',
                    Token: this.$session.get("Token"),
                }
                this.$PostData(DataAxios_Data)
                .then(data=>{
                    var Users=[]
                    this.users= data
                    data.forEach(element => {
                            Users.push(element)
                            this.value3.push(element.id)
                    });
                    this.options3=Users
                }).finally(()=>{
                    this.$store.state.renderComponentGrid=false
                    this.$nextTick(()=>{
                        this.$store.state.renderComponentGrid = true;
                    })
                })
        },
        SetData(IsCustomer){
            if (IsCustomer) {
               if (this.$ValidForm('InsertBoarsCustomer')) {
                    this.SendDataToApi(IsCustomer);
                }
            }
            else
            {
                if (this.$ValidForm('InsertBoarsUser')) {
                    this.SendDataToApi(IsCustomer);
                }
            }
            
        },
        SendDataToApi(IsCustomer){
            let DataAxios_SetData={
                    ArryfildValue: {},
                    Method: "post",
                    Action: 'NoticeBoard/Set_BoardUser',
                    Token: this.$session.get("Token"),
                }
                let TblNoticeBoardRizList=[]
                if(!IsCustomer){
                    for (let index = 0; index < this.value3.length; index++) {
                        const element = this.value3[index];
                        var model={Id:1,ReadMessage:0,IsCustomer:0,tblUserId:element,tblNoticeBoardId:1,tblUserGrpIdInsert:this.$session.get('UserInfo').tblUserGrpId,tblUserGrpIdLastEdit:null,}
                        TblNoticeBoardRizList.push(model)
                    }
                }
                else
                { 
                    DataAxios_SetData.Action='NoticeBoard/Set_BoardCustomer'
                    this.DataAxios.IsCustomer=true
                }
                this.DataAxios.TblNoticeBoardRiz=TblNoticeBoardRizList
                // console.log('this.DataAxios save', this.DataAxios);
                DataAxios_SetData.ArryfildValue=this.DataAxios
                this.$PostData(DataAxios_SetData)
                .then(data=>{
                    this.AddModeUser=0
                    this.AddModeCustomer=0
                    this.Reload();
                }).finally(()=>{
                    this.$store.state.renderComponentGrid=false
                    this.$nextTick(()=>{
                        this.$store.state.renderComponentGrid = true;
                    })
                })
        },
        GetCol(){
            this.$GetColumns(this.DataAxoisCol, true)
            .then((data) => {
                this.Column = data
            })
            .finally(() => {
                this.$store.state.renderComponentGrid = false
                this.$nextTick(() => {
                
                this.$store.state.renderComponentGrid = true
                })
            })
        },
        GetRowCustomer(){
            let DataAxios_GetNotices={
                    ArryfildValue: {},
                    Method: "post",
                    Action: 'NoticeBoard/Get_BoardUser',
                    Token: this.$session.get("Token"),
                }
                DataAxios_GetNotices.ArryfildValue.IsCustomer=true
                this.$PostData(DataAxios_GetNotices)
                .then(data=>{
                   this.RowsCustomer=data.Result
                }).finally(()=>{
                    this.$store.state.renderComponentGrid=false
                    this.$nextTick(()=>{
                        this.$store.state.renderComponentGrid = true;
                    })
                })
        },
        GetRow(){
            let DataAxios_GetNotices={
                    ArryfildValue: {},
                    Method: "post",
                    Action: 'NoticeBoard/Get_BoardUser',
                    Token: this.$session.get("Token"),
                }
                DataAxios_GetNotices.ArryfildValue.IsCustomer=false
                this.$PostData(DataAxios_GetNotices)
                .then(data=>{
                   this.Rows=data.Result
                }).finally(()=>{
                    this.$store.state.renderComponentGrid=false
                    this.$nextTick(()=>{
                        this.$store.state.renderComponentGrid = true;
                    })
                })
        },
        Reload() {
            this.DataAxios=JSON.parse(JSON.stringify({Id:1,tblUserGrpIdInsert:this.$session.get('UserInfo').tblUserGrpId,DateTimeLastEdit:"",DateTimeInsert:"",tblUserGrpIdLastEdit:0,IsCustomer:0,Archive:0}))
            this.GetRowCustomer();
            this.GetRow();
        },
        OnDetail(row){
            this.GetColModel();
             let DataAxios_GetNoticesDetail={
                    ArryfildValue: {},
                    Method: "post",
                    Action: 'NoticeBoard/Get_BoardDetail',
                    Token: this.$session.get("Token"),
                }
                DataAxios_GetNoticesDetail.ArryfildValue.tblNoticeBoardId=row.Id
                this.$PostData(DataAxios_GetNoticesDetail)
                .then(data=>{
                   this.RowsRiz=data.Result;
                }).finally(()=>{
                    this.$bvModal.show('modal-NoticesRiz')
                    this.$store.state.renderComponentGridModal=false
                    this.$nextTick(()=>{
                        this.$store.state.renderComponentGridModal = true;
                    })
                })
        },
        GetColModel(){
            this.$GetColumns(this.DataAxoisColRiz, true)
            .then((data) => {
                this.ColumnRiz = data
            })
            .finally(() => {
                this.$store.state.renderComponentGridModal = false
                this.$nextTick(() => {
                
                this.$store.state.renderComponentGridModal = true
                })
            })
        }
    },
    mounted() {
        this.GetDataUser();
        this.GetCol();
        this.GetRowCustomer();
        this.GetRow();
    }
}
</script>
<style scoped>

</style>